import TravelerInfoUIModel from './travelerInfo';
import CurrencyValueUIModel from './currency-value';

class ManageCartPurchased {
  constructor({
    couponCode = undefined,
    couponTotal = undefined,
    discountTotal = undefined,
    travelerInfo = undefined,
    _meta = undefined,
    travelersCode = undefined,
  } = {}) {
    this.couponCode = couponCode;
    this.couponTotal = couponTotal;
    this.discountTotal = discountTotal;
    if (travelerInfo !== undefined) {
      this.travelerCollection = travelerInfo._collection.map(travelerData => {
        return new TravelerInfoUIModel(travelerData);
      });
    }
    if (_meta !== undefined) {
      this.cartId = _meta.cartId;
      this.total = _meta.total.currency ? new CurrencyValueUIModel(_meta.total.currency) : _meta.total.currency;
      this.points = _meta.total.points;
    }
    this.travelersCode = travelersCode;
  }

  getCartCurrencyCode() {
    return this.total ? this.total.currencyCode : null;
  }

  getCartTotal() {
    return this.total ? this.total.getTotal() : null;
  }

  getCartTotalPoints() {
    return this.total ? this.total.getTotalPoints() : null;
  }

  /**
    * Devuelve el total de impuestos
  */
  getTotalTax() {
    return this.total.getTotalTax();
  }

  /**
    * Lista de Impuestos
    * Devuelve pares de código y valor.
    * @return {[string, number][]} Devuelve una matriz de pares [taxCode, value], e.g. [["VAT", 10.99], ["OT", 1.50]]
  */
  getTaxDetailsAsList() {
    return this.total.getTaxDetailsAsList();
  }

  buildFullAncillariesList(ancillariesByTraveler) {
    const ancillaries = new Array();
    ancillariesByTraveler.forEach(traveler => {
      traveler.forEach(ancillary => {
        ancillaries.push(ancillary);
      });
    });
    return ancillaries;
  }

  getTicketedAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getTicketedAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getTicketedAncillariesFlyGreen() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getTicketedAncillariesFlyGreen();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getTicketedAncillariesPriority() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getTicketedAncillariesPriority();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getTicketedUpgradeType() {
    return this.travelerCollection[0].getTicketedUpgradeType();
  }

  getTicketedUpgradeSegmentCodes() {
    return this.travelerCollection[0].getTicketedUpgradeSegmentCodes();
  }

  getAllTicketedAncillaries() {
    const ancillariesByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getAllTicketedAncillaries();
    });

    return this.buildFullAncillariesList(ancillariesByTraveler);
  }

  getAllTicketedCBX() {
    const cbxByTraveler = this.travelerCollection.map(traveler => {
      return traveler.getAllTicketedCBX();
    });

    return this.buildFullAncillariesList(cbxByTraveler);
  }

  hasTicketedAncillary() {
    let hasTicketedAncillary = false;
    hasTicketedAncillary = this.travelerCollection.find(traveler => {
      return traveler.hasTicketedAncillary() ? true : false;
    });
    return hasTicketedAncillary !== undefined ? true : false;
  }

  hasTicketedAncillaryPP() {
    return !!this.travelerCollection.find(traveler => {
      return traveler.hasTicketedAncillaryPP();
    });
  }

  hasTicketedSeat() {
    let hasTicketedSeat = false;
    hasTicketedSeat = this.travelerCollection.find(traveler => {
      return traveler.hasTicketedSeat() ? true : false;
    });
    return hasTicketedSeat !== undefined ? true : false;
  }

  hasTicketedSeatPP() {
    let hasTicketedSeatPP = false;
    hasTicketedSeatPP = this.travelerCollection.find(traveler => {
      return traveler.hasTicketedSeatPP() ? true : false;
    });
    return hasTicketedSeatPP !== undefined ? true : false;
  }

  hasTicketedUpgrade() {
    let hasTicketedUpgrade = false;

    hasTicketedUpgrade = this.travelerCollection.find(traveler => {
      return traveler.hasTicketedUpgrade();
    });

    return hasTicketedUpgrade ? true : false;
  }

  getBaggageTicketedAncillaries() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getBaggageTicketedAncillaries();
    });
    return baggageByTraveler;
  }

  getCarryOnTicketedAncillaries() {
    const carryOnByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      carryOnByTraveler[travelerInfo.id] = travelerInfo.getCarryOnTicketedAncillaries();
    });
    return carryOnByTraveler;
  }

  getSpecialBaggageTicketedAncillaries() {
    const baggageByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      baggageByTraveler[travelerInfo.id] = travelerInfo.getSpecialBaggageTicketedAncillaries();
    });
    return baggageByTraveler;
  }

  getUnPaidSegmentChoice(segments) {
    const segmentChoiceByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      segmentChoiceByTraveler[travelerInfo.id] = travelerInfo.getUnPaidSegmentChoice(segments);
    });
    return segmentChoiceByTraveler;
  }

  getTicketedSegmentChoice(segments) {
    const segmentChoiceByTraveler = {};
    this.travelerCollection.forEach(travelerInfo => {
      segmentChoiceByTraveler[travelerInfo.id] = travelerInfo.getTicketedSegmentChoice(segments);
    });
    return segmentChoiceByTraveler;
  }

  getTicketedSeatChoice(segments) {
    const segmentChoices = new Array();
    this.travelerCollection.forEach(travelerInfo => {
      travelerInfo.getAllUnPaidSegmentChoice(segments).forEach(segmentChoice => {
        segmentChoices.push(segmentChoice);
      });
    });
    return segmentChoices;
  }

  getAllPassengers() {
    return this.travelerCollection;
  }
}

export default ManageCartPurchased;
